<template>
  <el-dialog :title="$t('addOrg.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="addOrgInfo" :rules="rules" ref="addOrgForm" label-width="120px">
      <el-form-item :label="$t('addOrg.orgName')" prop="orgName">
        <el-input v-model="addOrgInfo.orgName" :placeholder="$t('addOrg.orgNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addOrg.parentOrg')" prop="parentOrgName">
        <el-input v-model="addOrgInfo.parentOrgName" disabled
          :placeholder="$t('addOrg.parentOrgPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addOrg.description')" prop="description">
        <el-input type="textarea" :rows="3" :placeholder="$t('addOrg.descriptionPlaceholder')"
          v-model="addOrgInfo.description"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveOrgInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveOrg } from '@/api/frame/orgApi'

export default {
  name: 'AddOrg',
  data() {
    return {
      dialogVisible: false,
      addOrgInfo: {
        orgId: '',
        orgName: '',
        orgLevel: '',
        parentOrgId: '',
        parentOrgName: '',
        description: '',
        belongCommunityId: ''
      },
      rules: {
        orgName: [
          { required: true, message: this.$t('addOrg.orgNameRequired'), trigger: 'blur' },
          { min: 2, max: 50, message: this.$t('addOrg.orgNameLength'), trigger: 'blur' }
        ],
        parentOrgId: [
          { required: true, message: this.$t('addOrg.parentOrgRequired'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('addOrg.descriptionLength'), trigger: 'blur' }
        ]
      },
      flagOrgName: false
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.resetForm()
        if (params) {
          this.addOrgInfo.parentOrgId = params.parentOrgId
          this.addOrgInfo.parentOrgName = params.parentOrgName
        }
      })
    },
    saveOrgInfo() {
      this.$refs.addOrgForm.validate(valid => {
        if (!valid) return

        if (this.$parent.callBackListener && this.$parent.callBackFunction) {
          this.$emit(this.$parent.callBackListener, this.$parent.callBackFunction, this.addOrgInfo)
          this.dialogVisible = false
          return
        }

        saveOrg(this.addOrgInfo).then(response => {
          this.$message.success('添加组织成功')
          this.dialogVisible = false
          this.resetForm()
          this.$emit('refresh')
        }).catch(error => {
          this.$message.error((error && error.message) || '添加组织失败')
        })
      })
    },
    resetForm() {
      this.$refs.addOrgForm && this.$refs.addOrgForm.resetFields()
      this.addOrgInfo = {
        orgId: '',
        orgName: '',
        orgLevel: '',
        parentOrgId: '',
        parentOrgName: '',
        description: '',
        belongCommunityId: ''
      }
    },
    handleClose() {
      this.resetForm()
    },
    textOrgName() {
      console.log(this.flagOrgName)
    }
  }
}
</script>